import React from 'react';

export const GreenHouseIframe = (): JSX.Element => {
  return <div id="grnhse_app" title="Greenhouse Integration"></div>;
};
